<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div [formGroup]="form"
  class="component-wrapper">
  <div class="label-wrapper">
    @if (label) {
      <label
        [ngClass]="{'small': isSmallLabel}"
        for="{{HTML_ID}}">
        <span [attr.data-cy]="labelCypressTag">{{label}}</span>
      </label>
    }
    @if (hasWarningStar) {
      <app-warning-star
        [attr.data-cy]="warningStarCypressTag"
      [type]="warningLevel"></app-warning-star>
    }
    <div [attr.data-cy]="labelInformationCypressTag"
      class="label-information">
      <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
    </div>
  </div>

  <fieldset id="{{HTML_ID}}">
    @for (option of options; track option; let index = $index) {
      <div
        class="option">
        <input #inputOption
          (change)="inputValueChange.emit(option)"
          [checked]="isDefaultChecked(option)"
          [attr.data-cy]="optionInputCypressTag(index)"
          id="{{HTML_ID}}-{{index}}"
          name="name-{{HTML_ID}}"
          type="radio">
        <label for="{{HTML_ID}}-{{index}}"
        [attr.data-cy]="optionLabelCypressTag(index)">{{optionTransform(option)}}</label>
      </div>
    }
  </fieldset>
</div>
